import React from 'react';
import _ from 'lodash';
import {
  WiFiButton, VersionButton, Title,
  OneImgInFull,
  OneImgWithGap,
  OneImgWithIntro,
  RightImgWithIntro,
  BannerImg,
  Movie,
  MovieContainer,
  Text,
  Container,
  Image,
  Button,
  FAQ,
  Rule,
  Coupon,
  RegForm,
  CouponContainer
} from '@/components';
import {pxToVW} from './pxToVW';
const componentsMap = {
  'Text': Text,
  'Image': Image,
  'Button': Button,
  'Container': Container,
  'BannerImg': BannerImg,
  'Title': Title,
  'WiFiButton': WiFiButton,
  'VersionButton': VersionButton,
  'OneImgInFull': OneImgInFull,
  'OneImgWithGap': OneImgWithGap,
  'OneImgWithIntro': OneImgWithIntro,
  'RightImgWithIntro': RightImgWithIntro,
  'Movie': Movie,
  'MovieContainer': MovieContainer,
  'FAQ': FAQ,
  'Rule': Rule,
  'Coupon': Coupon,
  'RegForm': RegForm,
  'CouponContainer':CouponContainer
}

export function getChildren(components) {

  let childrenComponent;
  if(components !== undefined) {
    childrenComponent = components.map((component, index) => {
    const Child = getChildren(component.children)
    const Children = componentsMap[component.name];
    const style = component.props.style && pxToVW(component.props.style);
    const newProps = {
      ...component.props,
      style: _.isEmpty(style) ? undefined : style
    }
    return Children && (
      <Children key={index} {...newProps}>{Child}</Children>
    )
  });
}
  return childrenComponent;
}
export function getComponents(config, handleChangePage, params) {
  const Components = config.map(componentConig => {
    const { name, children, props = {}, id } = componentConig
    const childrenConig = props.children || children
    const style = props.style && pxToVW(props.style);
    const Component = componentsMap[name];
    const newProps = {
      ...props,
      ...params,
      handleChangePage:(router,data)=>handleChangePage(router,data),
      children: childrenConig && !_.isEmpty(childrenConig) && getComponents(childrenConig, handleChangePage, params),
      style: _.isEmpty(style) ? undefined : style
    }
    return Component && (
      <Component 
      key={id}
      id={id}
      {...newProps} />);
  });

  return Components;
}

export function isBlockEnv() {
  return !(window.location.host === 'static.ccrgt.com' || window.location.host === 't-static.ccrgt.com') ;
}
